module.exports = __webpack_public_path__ + "static/owl-59d8aa6e221a9271e20ea29f53453d5e.svg";